// Service gọi API báo cáo điểm kỳ thi

export async function fetchExamScoreReport(params: any) {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`/api/v1/report/scores?${query}`);
  if (!res.ok) throw new Error('Lỗi lấy báo cáo điểm');
  const data = await res.json();
  return data.data || [];
}

export async function fetchExamScoreDetail(maHS: string, examSessionId: string, nguoiCham?: string) {
  let url = `/api/v1/report/scores/${maHS}/${examSessionId}`;
  if (nguoiCham) {
    url += `?nguoiCham=${encodeURIComponent(nguoiCham)}`;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error('Lỗi lấy chi tiết điểm');
  const data = await res.json();
  return data.data || {};
}

export async function exportExamScoreReport(params: any) {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`/api/v1/report/scores/export?${query}`, {
    method: 'GET',
  });
  if (!res.ok) throw new Error('Export failed');
  return await res.blob();
} 